<script>
   /*********************************************************
   * VariancePlot                                           *
   * --------------------                                   *
   * shows plot for explained variance                      *
   **********************************************************/

   import { diff } from 'mdatools/stat';
   import { Vector } from 'mdatools/arrays';
   import { Axes, XAxis, YAxis, Box } from 'svelte-plots-basic/2d';

   import { pcares_get } from '../wasm/pcvpca';

   import PlotSeries from './PlotSeries.svelte';
   import AppLegend from './AppLegend.svelte';


   /*****************************************/
   /* Input parameters                      */
   /*****************************************/

   export let model;                // PCA model object
   export let params;               // JSON with main plot parameters
   export let res;                  // JSON with results onkects

   // constant parameters
   const margins = [0.75, 1, 0.1, 0.5];
   const showGrid = true;
   const xLabel = "Components";
   const yLabel = "Relative variance";

   // compute and return explaned variance
   function get_series(res, params) {
      const cumexpvar = new Vector(pcares_get(res, "cumexpvar"));
      if (params.vartype == "cumexpvar") return cumexpvar;

      const out = Vector.zeros(res.ncomp);
      out.v[0] = cumexpvar.v[0];
      out.v.set(diff(cumexpvar.v).v, 1);
      return out;
   }

   // set titles
   $: title = params && params.vartype == "expvar" ? "Explained variance" : "Cumulative explained variance";

   // get values
   $: x = Vector.seq(1, model.ncomp);
   $: ps = res && params ? Object.keys(res).map(id => ({'id': id, 'x': x, 'y': get_series(res[id], params)})) : null;

   // set limits
   $: limX = model ? [0.5, model.ncomp + +.5] : [0, 1];
   $: limY = [-0.05, 1.1];
</script>

{#if ps && ps.length > 0}
<Axes {margins} {xLabel} {yLabel} {limX} {limY} {title} >

   {#each ps as series}
   <PlotSeries values={series} type="b" />
   {/each}

   <AppLegend position={params.vartype === "cumexpvar" ? "bottomright" : "topright"}/>
   <XAxis {showGrid} slot="xaxis" />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>
{/if}